import { Edit2, Inbox, Blocks } from "lucide-react";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { isBlockMode, MODE_META } from "../../lib/modes";

export function SubmissionsTab({ 
  submissions, 
  onOpenSubmissionEditor 
}) {
  const pendingSubmissions = submissions.filter(s => s.submission_status === "pending");
  
  return (
    <div className="bg-card rounded-2xl border border-border/40 p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="p-2 rounded-xl bg-amber-500/10">
          <Inbox className="w-5 h-5 text-amber-500" />
        </div>
        <div>
          <h2 className="font-heading font-semibold text-lg">User Question Submissions</h2>
          <p className="text-sm text-muted-foreground">
            Review and approve user-submitted questions
          </p>
        </div>
      </div>

      {pendingSubmissions.length === 0 ? (
        <div className="text-center py-12 text-muted-foreground">
          <Inbox className="w-12 h-12 mx-auto mb-4 opacity-50" />
          <p>No pending submissions</p>
        </div>
      ) : (
        <div className="space-y-4">
          {pendingSubmissions.map((submission) => (
            <div
              key={submission.question_id}
              className="border border-border rounded-xl p-4 cursor-pointer hover:border-primary/50 hover:bg-muted/30 transition-colors"
              onClick={() => onOpenSubmissionEditor(submission)}
              data-testid={`submission-${submission.question_id}`}
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="font-semibold text-lg">{submission.title}</h3>
                    {isBlockMode(submission.mode) && (
                      <Badge className={`text-xs gap-1 ${MODE_META[submission.mode].badge}`} variant="outline" data-testid={`submission-mode-${submission.question_id}`}>
                        <Blocks className="w-3 h-3" /> {MODE_META[submission.mode].label}
                      </Badge>
                    )}
                    <Badge variant="outline" className="text-xs">Click to review</Badge>
                  </div>
                  <p className="text-sm text-muted-foreground mb-2">
                    Submitted by: {submission.created_by_nickname || "Unknown"}
                  </p>
                  <p className="text-sm mb-4 line-clamp-2">{submission.description}</p>
                  
                  <div className="flex items-center gap-4 text-xs text-muted-foreground">
                    <span>{submission.mode === "junior" || submission.blocks?.kind === "nav" ? "Navigation grid" : `${submission.test_cases?.length || 0} test cases`}</span>
                    <span>•</span>
                    <span>{new Date(submission.created_at).toLocaleDateString()}</span>
                  </div>
                </div>
                
                <div className="flex gap-2 ml-4" onClick={(e) => e.stopPropagation()}>
                  <Button
                    size="sm"
                    variant="outline"
                    className="gap-1"
                    onClick={() => onOpenSubmissionEditor(submission)}
                    data-testid={`edit-${submission.question_id}`}
                  >
                    <Edit2 className="w-4 h-4" />
                    Review
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
